(ns ui.view.card.survey-processes.view
  (:require
   [ui.view.card.shared-components.card-title :as card-title]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.entity-table :as entity-table]
   [ui.view.card.survey-processes.event :as event]
   [ui.view.card.survey-processes.sub :as sub]
   [ui.view.card.sub :as common-sub]
   [ui.state.session.sub :as session-sub]
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.view.card.entity-list.view :as entity-list-view]
   [ui.components.button.view :as button]
   [ui.view.card.shared-components.view :as card-shared]
   [ui.view.card.shared-components.full-screen-card :as full-screen-card]
   [clojure.string :as string]
   [ui.util :as uu]))

(defn add-new-survey-process-button
  [{:keys [preview-mode? primary-button? read-only-user? ctx] :as _props}]
  (let [survey-profile (get @(rf/subscribe [::common-sub/entities ctx])
                            (:entity-id ctx))
        {:keys [visible? disabled? missing-contact?]}
        (sub/create-process-button-state
         {:preview-mode? preview-mode?
          :read-only-user? read-only-user?
          :survey-profile survey-profile})
        component (if primary-button?
                    button/sm-primary-solid
                    button/sm-secondary-hollow)]
    (when visible?
      [component
       {:disabled? disabled?
        :tooltip (when missing-contact?
                   (loc/tr :please-select-their-survey-contact))
        :on-click (fn [_event]
                    (rf/dispatch [::event/create-process ctx]))}
       [:i {:class "fal fa-plus"}]
       (loc/tr :add- [(-> :entity.type/survey-process loc/tr string/lower-case)])])))

(defn empty-state-view
  [props]
  [:div
   {:class "flex flex-col items-center gap-4 py-5"}
   [:div
    {:class "relative"}
    [:div
     {:class "absolute -bottom-1 -right-2 flex items-center justify-center bg-base-light rounded-full w-7 h-7"}
     [:i {:class "fal fa-file text-2xl"}]]]
   [:p
    {:class "text-lg font-semibold"}
    (loc/tr :no-survey-processes-yet)]
   [:div
    {:class "flex justify-center"}
    [add-new-survey-process-button
     (assoc props :primary-button? true)]]])

(defn table-view
  [{:keys [card ctx]}]
  (let [table-data @(rf/subscribe [::sub/table-data ctx])
        columns (-> card :card/config :table-config :columns)
        peek-entity-id @(rf/subscribe [::common-sub/entity-peek-entity-id ctx])
        read-only-user? @(rf/subscribe [::session-sub/read-only-user?])]
    [:div
     {:class "flex flex-col gap-5 grow"}
     [entity-table/view
      {:columns columns
       :config (-> card :card/config :table)
       :data table-data
       :selected-row-id peek-entity-id
       :on-row-clicked (fn [args]
                         (when-not read-only-user?
                           (let [process-id (:entity-id args)
                                 survey-profile-id (:entity-id ctx)]
                             (rf/dispatch [::event/open-process ctx {:process-id process-id
                                                                     :profile-id survey-profile-id}]))))}]]))

(defn component
  [{:keys [card ctx] :as props}]
  (let [title (:card/title card)
        process-count @(rf/subscribe [::sub/survey-process-count ctx])
        processes? (pos? process-count)
        loading? @(rf/subscribe [::common-sub/loading? ctx])
        read-only-user? @(rf/subscribe [::session-sub/read-only-user?])
        view-props (assoc props :read-only-user? read-only-user?)]
    [card-container/view
     {}
     [:div
      {:class "flex"}
      [:div
       {:class "flex flex-col gap-2 grow"}
       [:div
        {:class "flex justify-between min-h-12 items-start"}
        [card-title/view title]
        [:div
         {:class "flex gap-2 items-center"}
         (when processes?
           [add-new-survey-process-button view-props])
         [card-shared/expand-card view-props]]]
       (cond
         loading? [entity-list-view/loading-skeleton]
         processes? [table-view view-props]
         :else [empty-state-view view-props])]]]))

(defn full-screen-component
  [{:keys [ctx] :as props}]
  (let [process-count @(rf/subscribe [::sub/survey-process-count ctx])
        processes? (pos? process-count)
        loading? @(rf/subscribe [::common-sub/loading? ctx])
        read-only-user? @(rf/subscribe [::session-sub/read-only-user?])
        empty-state? (and (not loading?)
                          (not processes?))
        view-props (assoc props :read-only-user? read-only-user?)
        full-screen-props (cond-> view-props
                            (and processes?
                                 (not read-only-user?))
                            (assoc :header-right-actions
                                   [add-new-survey-process-button view-props]))]
    [full-screen-card/view
     full-screen-props
     [:div
      {:class (uu/cm "flex w-full h-full grow justify-center"
                     (when empty-state?
                       "items-center"))}
      (cond
        loading? [entity-list-view/loading-skeleton]
        processes? [table-view view-props]
        :else [empty-state-view view-props])]]))

(defn view
  [{:keys [full-screen?] :as props}]
  [:<>
   (if full-screen?
     [full-screen-component props]
     [component props])])
